module.exports = __webpack_public_path__ + "img/1215184439.96e1351a.jpg";